import React, { useState } from "react";
import { Check, Copy } from "lucide-react";
import { toast } from "sonner";
import { cn } from "@/lib/utils";

const CopyPhoneButton = ({ phone, isDark, className, size = "sm" }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (!phone) return;
    try {
      await navigator.clipboard.writeText(String(phone));
      setCopied(true);
      toast.success("Numara kopyalandı");
      setTimeout(() => setCopied(false), 1600);
    } catch {
      toast.error("Kopyalanamadı");
    }
  };

  const iconClass = size === "xs" ? "w-2.5 h-2.5" : "w-3 h-3";
  const btnClass = size === "xs" ? "w-5 h-5" : "w-6 h-6";

  return (
    <button
      type="button"
      onClick={handleCopy}
      title="Numarayı kopyala"
      aria-label="Numarayı kopyala"
      className={cn(
        "inline-flex items-center justify-center rounded-md shrink-0 opacity-50 hover:opacity-100 transition-all",
        btnClass,
        isDark ? "hover:bg-slate-700/80 text-slate-400 hover:text-slate-200" : "hover:bg-gray-200/80 text-gray-500 hover:text-gray-800",
        className
      )}
    >
      {copied ? <Check className={cn(iconClass, "text-emerald-500")} /> : <Copy className={iconClass} />}
    </button>
  );
};

export default CopyPhoneButton;
